import router from "./router";
import store from "./store";

import App from "./App.vue";

import "flag-icons/css/flag-icons.css";
import "@/scss/index.scss";

import { createApp } from "vue";

import vuetify from "./plugins/vuetify";

const app = createApp(App);
app.use(store);
app.use(router);
app.use(vuetify);

app.mount("#app");
